import _defineProperty from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/build/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["children", "matchtype", "ignore"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Children, cloneElement, useState, useEffect } from "react";
import Link from "next/link";
import { useRouter } from "next/router";
import { jsx as _jsx } from "react/jsx-runtime";
function match(type, a, b) {
  if (type === "full") {
    return a === b;
  } else if (type === "partial") {
    return b.startsWith(a);
  }
}
export default function ActiveLink(_ref) {
  let {
      children,
      matchtype = "full",
      ignore = null
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  const router = useRouter();
  const child = Children.only(children);
  const childClassName = child.props.className || "";
  const {
    0: className,
    1: setClassName
  } = useState(childClassName);
  useEffect(() => {
    let className = childClassName;
    if (!match(matchtype, ignore, router.asPath) && (match(matchtype, props.href, router.asPath) || match(matchtype, props.as, router.asPath))) {
      className = `${childClassName} active`.trim();
    }
    setClassName(className);
  }, [props.href, props.as, childClassName, router.asPath]);
  return /*#__PURE__*/_jsx(Link, _objectSpread(_objectSpread({}, props), {}, {
    legacyBehavior: true,
    children: /*#__PURE__*/cloneElement(child, {
      className
    })
  }));
}